/* global axios */

import ApiClient from './ApiClient';

class AuditLogs extends ApiClient {
  constructor() {
    super('audit_logs', { accountScoped: true });
  }

  // filters: user_id, type, from e to (dias yyyy-mm-dd). Valor vazio nao vai.
  get({ page, filters = {} } = {}) {
    const params = Object.entries(filters).reduce((result, [key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        result[key] = value;
      }
      return result;
    }, {});
    if (page) params.page = page;
    return axios.get(this.url, { params });
  }
}

export default new AuditLogs();
